import { Separator } from '@/common/ui/separator'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSimpleSearch } from '@/common/ui/table/data-table-simple-search'
import Heading from '@/common/shared/heading'
import useHasPermission from '@/common/hooks/useHasPermission'
import { OperatorGroupPermission } from '@/schema'
import { PlayerWithTagsModel } from '../../types'
import { createColumns } from './constants'

interface PlayersWithTagsListingProps {
	data: PlayerWithTagsModel[]
	total: number
	isLoading: boolean
}

export default function PlayersWithTagsListing({
	data,
	total,
	isLoading,
}: PlayersWithTagsListingProps) {
	const hasWritePermission = useHasPermission(
		OperatorGroupPermission.MANAGE_PLAYER_TAGS,
	)

	const columns = createColumns(hasWritePermission || false)

	return (
		<>
			<div className="space-y-4">
				{/* Header */}
				<Heading
					title="ผู้เล่นและแท็ก"
					description={`รายการผู้เล่นที่มีแท็ก ทั้งหมด ${total} คน`}
				/>
				<Separator />

				{/* Search */}
				<div className="flex flex-wrap items-end gap-4">
					<DataTableSimpleSearch placeHolder="ค้นหาเบอร์โทร" />
				</div>

				{/* Table */}
				<DataTablePaginate
					columns={columns}
					data={data}
					totalItems={total}
					isLoading={isLoading}
				/>
			</div>
		</>
	)
}
